import React from 'react';
import { formatCurrency, formatPercent } from '@/lib/format';
import type { ChartDataItem } from '@/types/charts';

interface CategoryLegendProps {
  /** Each item's `fill` is its category colour — the legend dot matches the slice and the Categorias dot. */
  data: ChartDataItem[];
}

export const CategoryLegend: React.FC<CategoryLegendProps> = ({ data }) => {
  return (
    // w-full: stacked under the pie the parent centres its children, which sizes the legend to its content, and a
    // long category name would then push the row past the viewport instead of truncating.
    <div className="w-full flex-1 min-w-0 space-y-3">
      {data.map((item) => (
        <div key={item.name} className="flex items-center justify-between gap-4 min-w-0">
          <div className="flex items-center gap-2 min-w-0">
            <div
              className="w-2.5 h-2.5 rounded-full shrink-0"
              style={{ backgroundColor: item.fill ?? 'hsl(var(--muted-foreground))' }}
              aria-hidden="true"
            />
            <span className="text-sm truncate" title={item.name}>
              {item.name}
            </span>
          </div>
          <div className="text-right shrink-0">
            <span className="text-sm font-medium tabular-nums">{formatCurrency(item.value)}</span>
            {item.percentage !== undefined && (
              <span className="text-xs text-muted-foreground ml-1.5">{formatPercent(item.percentage)}</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};
